module.exports = "#version 300 es\n\nuniform mat4 u_ViewProj;\nuniform float u_Time;\n\nuniform mat3 u_CameraAxes; // For rendering of particles as billboards\n\nin vec4 vs_Pos;\nin vec3 vs_SnowPos;\n\nout vec4 fs_Col;\nout vec4 fs_Pos;\nout vec4 fs_Nor;\n\nvoid main()\n{\n    fs_Pos = vs_Pos;\n    vec3 pos = vs_SnowPos.xyz;\n\n    // Movement of the snowflake\n    pos.y -= u_Time / 50.f;\n    pos.y = mod(pos.y, 150.f);\n\n    vec3 billboardPos =  pos + vs_Pos.x * u_CameraAxes[0] + vs_Pos.z * u_CameraAxes[1];\n    gl_Position = u_ViewProj * vec4(billboardPos, 1.f);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/snow-vert.glsl
// module id = 83
// module chunks = 0